import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import copy from "clipboard-copy";

import { initBlankState } from "../gym-locations";
import { SettingsBackHandler } from "../../../coaching-portal/settings/components/SettingsBackHandler";
import SettingsNav from "../../../../parts/settings-nav";
import SvgIcon from "../../../../parts/SvgIcon";
import TooltipPortal from "../../../../parts/tooltip-portal";

const EditGymComponent = ({ locals }) => {
  const { t } = useTranslation(["dashboard", "common"]);
  const { activeGymLocation = {} } = locals;
  const {
    daysWithSameAsAbove = [""],
    facilikey = "",
    gymLocation = "",
    gymMapLink = "",
    gymName = "",
    gymEmail = "",
    gymContact = "",
    workingDays = [""],
    days = [],
  } = activeGymLocation;

  const [dayState, setDayState] = useState([""]);
  const [sameAsAboveState, setSameAsAboveState] = useState([""]);
  const [formState, setFormState] = useState(initBlankState);

  useEffect(() => {
    //find to set the init state
    const friday = days.find(({ day }) => day === "Friday");
    const monday = days.find(({ day }) => day === "Monday");
    const saturday = days.find(({ day }) => day === "Saturday");
    const sunday = days.find(({ day }) => day === "Sunday");
    const thursday = days.find(({ day }) => day === "Thursday");
    const tuesday = days.find(({ day }) => day === "Tuesday");
    const wednesday = days.find(({ day }) => day === "Wednesday");

    //init state
    const initState = {
      endHoursOfOperationOfFriday: friday?.endHoursOfOperation
        ? friday.endHoursOfOperation
        : "",
      endHoursOfOperationOfMonday: monday?.endHoursOfOperation
        ? monday.endHoursOfOperation
        : "",
      endHoursOfOperationOfSaturday: saturday?.endHoursOfOperation
        ? saturday.endHoursOfOperation
        : "",
      endHoursOfOperationOfSunday: sunday?.endHoursOfOperation
        ? sunday.endHoursOfOperation
        : "",
      endHoursOfOperationOfThursday: thursday?.endHoursOfOperation
        ? thursday.endHoursOfOperation
        : "",
      endHoursOfOperationOfTuesday: tuesday?.endHoursOfOperation
        ? tuesday.endHoursOfOperation
        : "",
      endHoursOfOperationOfWednesday: wednesday?.endHoursOfOperation
        ? wednesday.endHoursOfOperation
        : "",
      endHoursStaffHoursOfFriday: friday?.endHoursStaffHours
        ? friday.endHoursStaffHours
        : "",
      endHoursStaffHoursOfMonday: monday?.endHoursStaffHours
        ? monday.endHoursStaffHours
        : "",
      endHoursStaffHoursOfSaturday: saturday?.endHoursStaffHours
        ? saturday.endHoursStaffHours
        : "",
      endHoursStaffHoursOfSunday: sunday?.endHoursStaffHours
        ? sunday.endHoursStaffHours
        : "",
      endHoursStaffHoursOfThursday: thursday?.endHoursStaffHours
        ? thursday.endHoursStaffHours
        : "",
      endHoursStaffHoursOfTuesday: tuesday?.endHoursStaffHours
        ? tuesday.endHoursStaffHours
        : "",
      endHoursStaffHoursOfWednesday: wednesday?.endHoursStaffHours
        ? wednesday.endHoursStaffHours
        : "",
      initHoursOfOperationOfFriday: friday?.initHoursOfOperation
        ? friday.initHoursOfOperation
        : "",
      initHoursOfOperationOfMonday: monday?.initHoursOfOperation
        ? monday.initHoursOfOperation
        : "",
      initHoursOfOperationOfSaturday: saturday?.initHoursOfOperation
        ? saturday.initHoursOfOperation
        : "",
      initHoursOfOperationOfSunday: sunday?.initHoursOfOperation
        ? sunday.initHoursOfOperation
        : "",
      initHoursOfOperationOfThursday: thursday?.initHoursOfOperation
        ? thursday.initHoursOfOperation
        : "",
      initHoursOfOperationOfTuesday: tuesday?.initHoursOfOperation
        ? tuesday.initHoursOfOperation
        : "",
      initHoursOfOperationOfWednesday: wednesday?.initHoursOfOperation
        ? wednesday.initHoursOfOperation
        : "",
      initHoursStaffHoursOfFriday: friday?.initHoursStaffHours
        ? friday.initHoursStaffHours
        : "",
      initHoursStaffHoursOfMonday: monday?.initHoursStaffHours
        ? monday.initHoursStaffHours
        : "",
      initHoursStaffHoursOfSaturday: saturday?.initHoursStaffHours
        ? saturday.initHoursStaffHours
        : "",
      initHoursStaffHoursOfSunday: sunday?.initHoursStaffHours
        ? sunday.initHoursStaffHours
        : "",
      initHoursStaffHoursOfThursday: thursday?.initHoursStaffHours
        ? thursday.initHoursStaffHours
        : "",
      initHoursStaffHoursOfTuesday: tuesday?.initHoursStaffHours
        ? tuesday.initHoursStaffHours
        : "",
      initHoursStaffHoursOfWednesday: wednesday?.initHoursStaffHours
        ? wednesday.initHoursStaffHours
        : "",
      gymName,
      gymContact,
      gymEmail,
      facilikey,
      gymLocation,
      gymMapLink,
    };

    //set check days with same as above
    const initDaysWithSameAsAbove =
      typeof daysWithSameAsAbove === "string"
        ? daysWithSameAsAbove.split(",")
        : daysWithSameAsAbove;

    //set check for working days
    const initWorkingDays =
      typeof workingDays === "string" ? workingDays.split(",") : workingDays;

    setSameAsAboveState(initDaysWithSameAsAbove);
    setDayState(initWorkingDays);
    setFormState(initState);
  }, []);

  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  /**
   * handle checkbox in working days
   * @param {*} value
   */
  const handleSelectionChange = (value) => {
    let data = JSON.parse(JSON.stringify(dayState));
    if (!dayState.includes(value)) {
      data.length === 1 && data[0].length === 0
        ? (data = [value])
        : data.push(value);
    } else {
      if (dayState.length > 0) {
        const filetered = data.filter((val) => val != value);
        data = filetered.length > 0 ? filetered : [""];
      }
    }
    setDayState(data);
  };

  /**
   * Set the data with the above information
   * @param {*} day
   */
  const handleSameAsAboveData = (day) => {
    let endHoursOfOperationValue = "";
    let endHoursStaffHourValue = "";
    let initHoursOfOperationValue = "";
    let initHoursStaffHoursValue = "";

    if (day === "Tuesday") {
      endHoursOfOperationValue = formState["endHoursOfOperationOfMonday"];
      endHoursStaffHourValue = formState["endHoursStaffHoursOfMonday"];
      initHoursOfOperationValue = formState["initHoursOfOperationOfMonday"];
      initHoursStaffHoursValue = formState["initHoursStaffHoursOfMonday"];
    } else if (day === "Wednesday") {
      endHoursOfOperationValue = formState["endHoursOfOperationOfTuesday"];
      endHoursStaffHourValue = formState["endHoursStaffHoursOfTuesday"];
      initHoursOfOperationValue = formState["initHoursOfOperationOfTuesday"];
      initHoursStaffHoursValue = formState["initHoursStaffHoursOfTuesday"];
    } else if (day === "Thursday") {
      endHoursOfOperationValue = formState["endHoursOfOperationOfWednesday"];
      endHoursStaffHourValue = formState["endHoursStaffHoursOfWednesday"];
      initHoursOfOperationValue = formState["initHoursOfOperationOfWednesday"];
      initHoursStaffHoursValue = formState["initHoursStaffHoursOfWednesday"];
    } else if (day === "Friday") {
      endHoursOfOperationValue = formState["endHoursOfOperationOfThursday"];
      endHoursStaffHourValue = formState["endHoursStaffHoursOfThursday"];
      initHoursOfOperationValue = formState["initHoursOfOperationOfThursday"];
      initHoursStaffHoursValue = formState["initHoursStaffHoursOfThursday"];
    } else if (day === "Saturday") {
      endHoursOfOperationValue = formState["endHoursOfOperationOfFriday"];
      endHoursStaffHourValue = formState["endHoursStaffHoursOfFriday"];
      initHoursOfOperationValue = formState["initHoursOfOperationOfFriday"];
      initHoursStaffHoursValue = formState["initHoursStaffHoursOfFriday"];
    } else {
      endHoursOfOperationValue = formState["endHoursOfOperationOfSaturday"];
      endHoursStaffHourValue = formState["endHoursStaffHoursOfSaturday"];
      initHoursOfOperationValue = formState["initHoursOfOperationOfSaturday"];
      initHoursStaffHoursValue = formState["initHoursStaffHoursOfSaturday"];
    }

    const newState = Object.assign({}, formState, {
      [`endHoursOfOperationOf${day}`]: endHoursOfOperationValue,
      [`endHoursStaffHoursOf${day}`]: endHoursStaffHourValue,
      [`initHoursOfOperationOf${day}`]: initHoursOfOperationValue,
      [`initHoursStaffHoursOf${day}`]: initHoursStaffHoursValue,
    });

    setFormState(newState);
  };

  /**
   * handle checkbox in same as above
   * @param {*} day
   */
  const handleSameAsAbove = (day) => {
    //code for the check color
    let data = JSON.parse(JSON.stringify(sameAsAboveState));
    if (!sameAsAboveState.includes(day)) {
      data.length === 1 && data[0].length === 0
        ? (data = [day])
        : data.push(day);
    } else {
      if (sameAsAboveState.length > 0) {
        const filetered = data.filter((val) => val != day);
        data = filetered.length > 0 ? filetered : [""];
      }
    }
    setSameAsAboveState(data);

    //code for set the same data
    handleSameAsAboveData(day);
  };

  /**
   * save the form values
   * @param {*} e
   */
  const onInputChange = async (e) => {
    const { name, value } = e.target;

    const newState = Object.assign({}, formState, {
      [`${name}`]: value,
    });

    setFormState(newState);
  };

  /**
   * Validate maplink
   * @returns
   */
  const validateMapLink = () => {
    if (!formState["gymMapLink"]) {
      return true;
    }

    if (formState["gymMapLink"]) {
      const regex = /@([-0-9.]+),([-0-9.]+)/;
      const match = formState["gymMapLink"].match(regex);
      return match;
    }

    return false;
  };

  // Team Coach can view org settings but not change them — the server
  // already rejects the POST, this just keeps the save button from
  // silently failing.
  const isReadOnly = locals?.organizationRoleName === "Team Coach";
  const saveDisabled = isReadOnly || !validateMapLink();
  const saveTooltipMessage = isReadOnly
    ? t("settingsNav.readOnlyTooltip")
    : t("gymLocations.googleMapLinkTooltip");

  return (
    <main className="settings">
      <SettingsNav classNames="mobile-hidden" />
      <section className="add-new-gym">
        <header>
          <SettingsBackHandler title={t("gymLocations.editGym")} />
          <hgroup className="mobile-hidden">
            <a
              href={"/coaching-portal/settings/gym-locations"}
              role="button"
              data-button-type="secondary"
              data-icon-only
            >
              <SvgIcon
                width={20}
                height={20}
                src="/img/new-icons/back-button.svg"
                alt={t("common:back")}
              />
            </a>
            <p className="s1">{t("gymLocations.editGym")}</p>
          </hgroup>
        </header>
        <form
          id="form-storefront"
          method="POST"
          encType="multipart/form-data"
          data-noreset
        >
          <div className="row">
            <div className="input-group input-group-new-gym direction-form-column">
              <label className="label req" htmlFor="gymName">
                {t("branding.gymName")}
              </label>
              <input
                placeholder={t("gymLocations.enterGymName")}
                name="gymName"
                onChange={onInputChange}
                value={formState["gymName"]}
                type="text"
                className="text-input"
                required
                sz="large"
              />
            </div>
            <div className="input-group input-group-new-gym direction-form-column">
              <label className="label req" htmlFor="gymLocation">
                {t("gymLocations.location")}
              </label>
              <input
                placeholder={t("gymLocations.enterCityName")}
                name="gymLocation"
                onChange={onInputChange}
                value={formState["gymLocation"]}
                type="text"
                className="text-input"
                required
                sz="large"
              />
            </div>
          </div>
          <div className="row">
            <div className="input-group input-group-new-gym direction-form-column">
              <label className="label req" htmlFor="gymEmail">
                {t("gymLocations.gymEmail")}
              </label>
              <input
                placeholder={t("gymLocations.enterGymEmail")}
                name="gymEmail"
                onChange={onInputChange}
                value={formState["gymEmail"]}
                type="text"
                className="text-input"
                required
                sz="large"
              />
            </div>
            <div className="input-group input-group-new-gym direction-form-column">
              <label className="label req" htmlFor="gymContact">
                {t("gymLocations.gymContact")}
              </label>
              <input
                placeholder={t("gymLocations.enterGymContact")}
                name="gymContact"
                onChange={onInputChange}
                value={formState["gymContact"]}
                type="text"
                className="text-input"
                required
                sz="large"
              />
            </div>
          </div>
          <div className="row">
            <div className="input-group input-group-new-gym direction-form-column">
              <label
                className="label req"
                htmlFor="gymMapLink"
                style={!validateMapLink() ? { color: "#e90b34" } : {}}
              >
                {t("gymLocations.googleMapLink")}
              </label>
              <div className="input-with-copy">
                <img alt={t("gymLocations.linkAlt")} src="/img/new-icons/link.svg" />
                <input
                  placeholder={t("gymLocations.pasteGoogleMapLink")}
                  name="gymMapLink"
                  onChange={onInputChange}
                  value={formState["gymMapLink"]}
                  type="text"
                  className="text-input"
                  required
                  sz="large"
                />
                <button
                  data-button-type="secondary"
                  data-icon
                  data-icon-only
                  className={`copy-new-gym${
                    !formState["gymMapLink"] || !validateMapLink()
                      ? " invisible"
                      : ""
                  }`}
                  onClick={async (e) => {
                    e.preventDefault();
                    await copy(formState["gymMapLink"]);
                  }}
                >
                  <img alt={t("gymLocations.copyAlt")} src="/img/new-icons/copy.svg" />
                </button>
              </div>
            </div>
            <div className="input-group input-group-new-gym direction-form-column">
              <label className="label" htmlFor="facilikey">
                {t("gymLocations.facilikey")}
              </label>
              <div className="input-with-copy">
                <img alt={t("gymLocations.linkAlt")} src="/img/new-icons/link.svg" />

                <input
                  placeholder={t("gymLocations.pasteKey")}
                  name="facilikey"
                  onChange={onInputChange}
                  value={formState["facilikey"]}
                  type="text"
                  className="text-input"
                  sz="large"
                />
                <button
                  data-button-type="secondary"
                  data-icon
                  data-icon-only
                  className={`copy-new-gym${
                    !formState["facilikey"] ? " invisible" : ""
                  }`}
                  onClick={async (e) => {
                    e.preventDefault();
                    await copy(formState["facilikey"]);
                  }}
                >
                  <img alt={t("gymLocations.copyAlt")} src="/img/new-icons/copy.svg" />
                </button>
              </div>
            </div>

            {/* hidden inputs section */}
          </div>
          <section role="table-wrapper" data-borders-inside>
            <div>
              <input
                name="workingDays"
                defaultValue={dayState}
                style={{ display: "none" }}
              ></input>
              <input
                name="daysWithSameAsAbove"
                defaultValue={sameAsAboveState}
                style={{ display: "none" }}
              ></input>
              <input
                name="requestType"
                defaultValue="put"
                style={{ display: "none" }}
              ></input>
            </div>
            <table role="report-table">
              <thead>
                <tr>
                  <th></th>

                  <th className="gym-location-form-width">{t("gymLocations.workingDays")}</th>
                  <th className="gym-location-form-width">
                    {t("gymLocations.hoursOfOperations")}
                  </th>
                  <th>{t("gymLocations.staffHours")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="new-gym-main-table-content">
                {daysOfWeek.map((day, index) => {
                  const checked = dayState.includes(day);
                  const sameAsAbove = sameAsAboveState.includes(day);
                  return (
                    <tr className="new-gym-table-content" key={day}>
                      <td>
                        <SvgIcon
                          src={`/img/new-icons/${
                            checked ? "checked-square" : "unchecked-square"
                          }.svg`}
                          onClickFn={() => handleSelectionChange(day)}
                          noFilterOnLight={checked}
                        />
                      </td>
                      <td className="gym-location-form-width">{day}</td>
                      <td className="gym-location-form-width">
                        <div className="div-text-hours">
                          <input
                            placeholder="10:00 AM"
                            name={`initHoursOfOperationOf${day}`}
                            value={formState[`initHoursOfOperationOf${day}`]}
                            onChange={onInputChange}
                            type="time"
                            pattern="[0-9]{2}:[0-9]{2}"
                            className="text-input text-input-hour-div"
                            readOnly={sameAsAbove || !checked}
                          />
                          <span>{t("metrics.to")}</span>
                          <input
                            placeholder="10:00 PM"
                            name={`endHoursOfOperationOf${day}`}
                            value={formState[`endHoursOfOperationOf${day}`]}
                            onChange={onInputChange}
                            type="time"
                            pattern="[0-9]{2}:[0-9]{2}"
                            className="text-input text-input-hour-div"
                            readOnly={sameAsAbove || !checked}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="div-text-hours">
                          <input
                            placeholder="10:00 AM"
                            name={`initHoursStaffHoursOf${day}`}
                            value={formState[`initHoursStaffHoursOf${day}`]}
                            onChange={onInputChange}
                            type="time"
                            pattern="[0-9]{2}:[0-9]{2}"
                            className="text-input text-input-hour-div"
                            readOnly={sameAsAbove || !checked}
                          />
                          <span>{t("metrics.to")}</span>
                          <input
                            placeholder="10:00 PM"
                            name={`endHoursStaffHoursOf${day}`}
                            value={formState[`endHoursStaffHoursOf${day}`]}
                            onChange={onInputChange}
                            type="time"
                            pattern="[0-9]{2}:[0-9]{2}"
                            className="text-input text-input-hour-div"
                            readOnly={sameAsAbove || !checked}
                          />
                        </div>
                      </td>
                      <td>
                        {index !== 0 && (
                          <div
                            className="same-as-above-div"
                            onClick={
                              !dayState.includes(day)
                                ? null
                                : () => handleSameAsAbove(day)
                            }
                            aria-disabled={
                              !dayState.includes(day) ? true : undefined
                            }
                          >
                            <SvgIcon
                              src={`/img/new-icons/${
                                sameAsAboveState.includes(day)
                                  ? "tick-circle"
                                  : "radio-unchecked"
                              }.svg`}
                            />

                            <span className="same-as-above-text">
                              {t("gymLocations.sameAsAbove")}
                            </span>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
          <div className="gym-contract-buttons">
            {saveDisabled ? (
              <TooltipPortal body={saveTooltipMessage}>
                <button type="button" data-button-type="primary" disabled>
                  {t("common:save")}
                </button>
              </TooltipPortal>
            ) : (
              <button data-button-type="primary" type="submit">
                {t("common:save")}
              </button>
            )}
            <a
              data-button-type="secondary"
              data-action="cancel"
              role="button"
              href="/coaching-portal/settings/gym-locations"
            >
              {t("common:discard")}
            </a>
          </div>
        </form>
      </section>
    </main>
  );
};

module.exports = EditGymComponent;
